/*
 * @Author: Chris 
 * @Date: 2022-07-27 11:17:26 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-28 10:38:09
 */
 
<template>
  <div id="app">
    <component :is="layout">
      <router-view></router-view>
    </component>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {
    defaul_layout: "ordinary",
  },
  data() {
    return {};
  },

  computed: {
    layout() {
      return this.$route.meta.layout || this.defaul_layout;
    },
  },

  mounted() {},
  methods: {},
};
</script>
<style>
</style>
